var render, staticRenderFns
import script from "./statusLabel.vue?vue&type=script&lang=js&"
export * from "./statusLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecff76de",
  null
  
)

export default component.exports